import { customerCompanyState } from '../../model/details/company';
import { LegalForm, LegalFormLookup } from '../../types/LegalForms';
import { CustomerInstantLease } from '../../types/CustomerInstantLease';

function enrichInstantLeaseProps(transformed: any, instantLeaseCustomer?: CustomerInstantLease) {
    if (instantLeaseCustomer) {
        const untypedLegalForm = instantLeaseCustomer.company?.legalForm;
        const legalFormEntry = LegalFormLookup[untypedLegalForm as LegalForm];
        const phoneNumbers = instantLeaseCustomer.contactDetails?.phoneNumbers;
        const emails = instantLeaseCustomer.contactDetails?.emails;

        // prettier-ignore
        transformed = {
            ...transformed,
            legalFormEntry: legalFormEntry,

            legalForm: legalFormEntry ? legalFormEntry.label : untypedLegalForm,

            localCourt: instantLeaseCustomer.company?.localCourt,

            phoneNumber: phoneNumbers
                ?.find((it) => it.purpose === 'CONTACT_PURPOSE_DEFAULT')
                ?.value,

            emailDefault: emails
                ?.find((it) => it.purpose === 'CONTACT_PURPOSE_DEFAULT')
                ?.value,

            emailInvoice: emails
                ?.find((it) => it.purpose === 'CONTACT_PURPOSE_INVOICE')
                ?.value,

            emailSepa: emails
                ?.find((it) => it.purpose === 'CONTACT_PURPOSE_SEPA')
                ?.value,
        };
    }
    return transformed;
}

export default function transformContractState(
    data: { [key: string]: any },
    instantLeaseCustomer?: CustomerInstantLease
) {
    const map = new Map();
    let _transform = {};

    if (data.type === 'PRIVATE') {
        return {};
    }

    map.set('instantLeaseCustomer', 'instantLeaseCustomer');
    map.set('company.name', 'name');
    map.set('company.vatId', 'vatId');
    map.set('company.commercialRegisterNumber', 'commercialRegisterNumber');
    map.set('company.foundingDate', 'foundingDate');
    map.set('company.address.streetName', 'streetName');
    map.set('company.address.houseNumber', 'houseNumber');
    map.set('company.address.addressAddition', 'addressAddition');
    map.set('company.address.postalCode', 'postalCode');
    map.set('company.address.city', 'city');
    map.set('company.address.country', 'country');

    map.forEach((uiKey, apiKey) => {
        const [type, subKey, subKeyType] = apiKey.split('.');
        const [pType, pSubKey] = uiKey.split('.');
        let _val;

        // 3. rank : 3 keys like energyInfo.wltpInfo.co2EmissionCombined
        if (subKeyType && subKey && data[type][subKey]) {
            const _v = data[type][subKey][subKeyType];

            _val = _v === null ? customerCompanyState[pType][pSubKey] : data[type][subKey][subKeyType];
        }
        // 2. rank : 2 keys like energyInfo.nefzIsEmpty
        else if (subKey && data[type]) {
            _val = data[type][subKey];
        }
        // 1. rank : standard
        else {
            _val = data[apiKey] === null ? customerCompanyState[uiKey] : data[apiKey];
        }

        _transform = {
            ..._transform,
            [uiKey]: _val === null ? customerCompanyState[uiKey] : _val,
        };
    });
    _transform = enrichInstantLeaseProps(_transform, instantLeaseCustomer);
    return _transform;
}
